var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-/-Mobile-/-Giving-/-Not-Signed-In",
    transform: "translate(-283.000000, -12.000000)",
    fill: "#9B9B9B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(283.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4921213,10.9998242 L21.6909579,1.80113464 C22.103014,1.3890851 22.103014,0.721086696 21.6909579,0.309037155 C21.2789018,-0.103012385 20.6108927,-0.103012385 20.1988366,0.309037155 L11,9.50772673 L1.80116342,0.310443468 C1.3891073,-0.101606073 0.72109822,-0.101606073 0.309042094,0.310443468 C-0.103014031,0.722493008 -0.103014031,1.39049141 0.309042094,1.80254095 L9.50787867,11.0012305 L0.310448429,20.1985138 C-0.101607696,20.6105633 -0.101607696,21.2785617 0.310448429,21.6906113 C0.517179659,21.8959329 0.785789625,22 1.05580593,22 C1.32582223,22 1.59583853,21.8973392 1.80116342,21.6906113 L11,12.4919217 L20.1988366,21.6906113 C20.4055678,21.8959329 20.6741778,22 20.9441941,22 C21.2142104,22 21.4842267,21.8973392 21.6895516,21.6906113 C22.1016077,21.2785617 22.1016077,20.6105633 21.6895516,20.1985138 L12.4921213,10.9998242 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.65f96ae9a3e150f66e54b9abb52ce5af.svg";
export { ForwardRef as ReactComponent };